import React from 'react';
import {
  EmailExistErrorModal,
  NetworkErrorModal,
  SomethingWentWrongErrorModal,
  VpnErrorModal,
  LoginFailedErrorModal,
  TwoAuthLoginErrorModal,
  LoginTooManyRequestsModal,
  ServerIsUnavailableErrorModal,
} from '../ErrorModals';
import { ModalType } from '@/context/ModalContext';

interface Props {
  name: ModalType;
}

const ModalMapper: React.FC<Props> = ({ name }) => {
  if (!name) {
    return null;
  }

  if (name === ModalType.EMAIL_EXIST) {
    return <EmailExistErrorModal />;
  }

  if (name === ModalType.NETWORK_ERROR) {
    return <NetworkErrorModal />;
  }

  if (name === ModalType.SOMETHING_WENT_WRONG) {
    return <SomethingWentWrongErrorModal />;
  }

  if (name === ModalType.NEED_VPN) {
    return <VpnErrorModal />;
  }

  if (name === ModalType.WRONG_CAPTCHA) {
    return <SomethingWentWrongErrorModal />;
  }

  if (name === ModalType.INCORRECT_PASSWORD) {
    return <LoginFailedErrorModal />;
  }

  if (name === ModalType.TWO_AUTH_LOGIN) {
    return <TwoAuthLoginErrorModal />;
  }

  if (name === ModalType.ACCOUNT_AUTH_BLOCKED) {
    return <LoginTooManyRequestsModal />;
  }

  if (name === ModalType.SERVER_UNAVAILABLE) {
    return <ServerIsUnavailableErrorModal />;
  }

  return <SomethingWentWrongErrorModal />;
};

export default React.memo(ModalMapper);
